module.exports = __webpack_public_path__ + "static_pc/img/ba04.9d9156ca.png";